import styled from '@emotion/styled';
import Inbox from 'lucide-react/dist/esm/icons/inbox';

// 기본 URL 상수
export const DEFAULT_PROFILE_IMAGE = '/images/default-avatar.png';
export const DEFAULT_COVER_IMAGE = '/images/default-banner.png';

// 최상위 컨테이너 - 탭과 통일된 배경색 적용
export const ProfilePageWrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  height: 100%;
  min-height: 0;
  background-color: var(--theme-background, #ffffff);
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
`;

// 팔로우/로그인 버튼
export const FollowButton = styled.button<{ $isFollowing?: boolean }>`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  border-radius: 9999px;
  padding: 0.5rem 1rem;
  font-size: 0.875rem;
  font-weight: 500;
  transition: all 0.2s;

  ${({ $isFollowing }) =>
    $isFollowing
      ? `
    border: 1px solid var(--theme-border, #e5e7eb);
    background-color: white;
    color: #374151;
    &:hover {
      border-color: #ef4444;
      color: #ef4444;
    }
    `
      : `
    border: 1px solid #2563eb;
    background-color: #2563eb;
    color: white;
    &:hover {
      background-color: #1d4ed8;
      border-color: #1d4ed8;
    }
    `}

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

export const LoginButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  border-radius: 9999px;
  padding: 0.5rem 1rem;
  font-size: 0.875rem;
  font-weight: 500;
  border: 1px solid #e5e7eb;
  background-color: white;
  color: #374151;

  &:hover {
    background-color: #f9fafb;
  }
`;

// 액션 버튼 컨테이너
export const ActionButtonsContainer = styled.div`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing.sm};
`;

// 프로필 정보 컨테이너
export const ProfileInfoContainer = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: ${({ theme }) => theme.spacing.sm};
  margin-bottom: ${({ theme }) => theme.spacing.sm};

  @media (max-width: ${({ theme }) => theme.breakpoints.sm}) {
    flex-direction: column;
    align-items: flex-start;
    gap: ${({ theme }) => theme.spacing.sm};
    margin-bottom: ${({ theme }) => theme.spacing.md};
  }
`;

// 프로필 콘텐츠 컨테이너 - 탭과 통일된 배경색
export const ProfileContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding-top: calc(64px + ${({ theme }) => theme.spacing.md});
  background-color: var(--theme-background, #ffffff);
  flex: 1;
  min-height: 0;

  @media (max-width: ${({ theme }) => theme.breakpoints.sm}) {
    padding-top: calc(0px + ${({ theme }) => theme.spacing.xs});
    margin-top: -8px;
  }
`;

// 프로필 메타 데이터 영역 스타일
export const ProfileMetaContainer = styled.div`
  padding: 0 ${({ theme }) => theme.spacing.md};
  margin-bottom: ${({ theme }) => theme.spacing.md};
`;

export const UserInfoBlock = styled.div``;

export const UserDisplayName = styled.h2`
  font-size: 1.25rem;
  font-weight: 700;
  color: var(--theme-text, inherit);
`;

export const UserUsername = styled.p`
  color: var(--theme-text-secondary, #6b7280);
`;

export const BioText = styled.p`
  color: var(--theme-text, #374151);
`;

export const MetaInfoWrapper = styled.div`
  margin-top: ${({ theme }) => theme.spacing.sm};
`;

export const MetaItemsContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: ${({ theme }) => theme.spacing.md} ${({ theme }) => theme.spacing.sm};
  font-size: 0.875rem;
  color: var(--theme-text-secondary, #6b7280);
`;

export const MetaItem = styled.div`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing.xs};
`;

export const MetaLink = styled.a`
  color: var(--theme-primary, #3b82f6);
  font-size: inherit;
  
  &:hover {
    text-decoration: underline;
  }
`;

// 탭 영역 스타일
export const TabNavWrapper = styled.div`
  width: 100%;
  border-bottom: 1px solid var(--theme-border, #e5e7eb);
  background-color: var(--theme-background, #ffffff);
`;

export const TabNavInner = styled.div`
  padding: 0 ${({ theme }) => theme.spacing.md};
`;

// 탭 콘텐츠 영역 - 통일된 배경색 
export const TabContentWrapper = styled.div`
  width: 100%;
  background-color: var(--theme-background, #ffffff);
  flex: 1;
`;

// 빈 상태 메시지 스타일
export const EmptyStateWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: ${({ theme }) => theme.spacing.xl} ${({ theme }) => theme.spacing.md};
  margin: ${({ theme }) => theme.spacing.md};
  border: 1px dashed var(--my-card-background, #e5e7eb);
  border-radius: 0.5rem;
  background-color: var(--my-card-background, #f9fafb);
  text-align: center;
`;

export const EmptyStateIcon = styled(Inbox)`
  width: 3rem;
  height: 3rem;
  color: var(--theme-icon-muted, #9ca3af);
  margin-bottom: ${({ theme }) => theme.spacing.md};
`;

export const EmptyStateText = styled.p`
  color: var(--theme-text-secondary, #6b7280);
  font-size: 0.875rem;
`;
